module.exports = __webpack_public_path__ + "static/img/IMG_20240730_200214.fb0ee138.jpg";